export const cifDj = ["301 201","<g fill-rule='nonzero' fill='none'><path fill='#6AB2E7' d='M.5.5h300v200H.5z'/><path fill='#12AD2B' d='M.5 100.5h300v100H.5z'/><path fill='#FFF' d='M.5.5v200l86.603-50 86.603-50-86.603-50z'/><path fill='#D7141A' d='M66.787 75.5l6.205 19.098h20.081l-16.246 11.803 6.205 19.099-16.246-11.804L50.541 125.5l6.206-19.099L40.5 94.598h20.081z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-dj.js
// module id = null
// module chunks = 